import React from "react";
import moment from 'moment';
import Calendar from 'react-calendar';
import './../pages/style.css';
import getChiusura from "../services/getChiusura";
import addChiusura from "../services/addChiusura";
import deleteChiusura from "../services/deleteChiusura";
import Cookies from 'universal-cookie';
import Utils from "../utils/utils";

export default class GiorniListWidget extends React.Component {

    constructor (props){
        super(props);

        this.mark = []
        this.state = {value: []}

        const cookies = new Cookies();
        this.username = cookies.get('username', { path: '/' });
        this.token = cookies.get('token', { path: '/' });
    }

    async update(){
        var giorniChiusura = await getChiusura(this.username, this.token);
        var giorniArray = [];
        giorniChiusura.forEach(g => giorniArray.push(g.day));

        this.setState({value: giorniArray});
    }

    async componentDidMount(){
        await this.update();
    }


    getDate(){
        return this.state.value;
    }

    render (){

        return ( 
        <div style={mainClass}>
        <Calendar
            id={Math.random()}
            tileClassName={({ date }) => {
            if(this.state.value.find((x) => x === moment(date).format("DD-MM-YYYY"))){
                return  'giornoChiusura'
            } else {
                return 'react-calendar__tile'
            }
            }}

            onClickDay={async date => {
                var strDay = moment(date).format("DD-MM-YYYY");
                var index = this.state.value.indexOf(strDay);
                if (index != -1){
                    await deleteChiusura(this.username, this.token, strDay);
                } else {
                    let lezioni = await Utils.checkLessonsForDay(strDay);
                    if (lezioni.length > 0){
                        alert ('Impossibile aggiungere la chiusura\nEsistono delle lezioni per questo giorno:\n'+lezioni);
                        return;
                    }
                    await addChiusura(this.username, this.token, strDay);
                }
                
                this.update();
            }} ></Calendar>
        </div>
        )
    }
}

const mainClass = {
    padding: '5px',
    marginTop: 10,
}